import { KeyImage } from '@/api';
import { FindingsByOrgan } from '@/shared/model';
import { isEmpty } from '@/shared/util';

function isUniqueKeyImage(keyImage: KeyImage, existing: KeyImage[]): boolean {
  return !existing.some((item) => item.uuid === keyImage.uuid);
}

export function generateKeyImageLabelList(findings: FindingsByOrgan): KeyImage[] {
  const keyImageLabelList: KeyImage[] = [];

  const allFindings = Object.values(findings).flat();

  for (const item of allFindings) {
    const keyImages = item.renderedSummary.keyImages;

    if (isEmpty(keyImages)) {
      continue;
    }

    const validKeyImages = keyImages.filter((keyImage) =>
      isUniqueKeyImage(keyImage, keyImageLabelList),
    );

    keyImageLabelList.push(...validKeyImages);
  }

  return keyImageLabelList;
}
